import Link from '@/atoms/Link/Link'
import Image from 'next/image'

/* blocks */
import NewsLetterSubscriptionCard from '@/molecules/NewsletterSubscription/NewsLetterSubscriptionCard'

interface Props {
  className?: string
  posts: BlogPostList[]
}

function InfluencerDetailsAsideContent({
  className,
  posts
}: Props): JSX.Element {
  return (
    <div className={className}>
      <section className="mb-16">
        <h3 className="h4-mobile font-medium | mb-6">
          Pepper Blog and Articles
        </h3>
        <div className="space-y-8 pr-5 | max-h-44 overflow-auto">
          {posts.map(post => (
            <BlogCard key={post.id} blog={post} />
          ))}
        </div>
      </section>

      <section className="mb-16">
        <NewsLetterSubscriptionCard formSource="cml" />
      </section>
    </div>
  )
}

function BlogCard({ blog }: { blog: BlogPostList }) {
  return (
    <article>
      <Link href={`/blog/${blog.slug}/`} className="flex items-center gap-5">
        {blog.featuredImage?.node.sourceUrl && (
          <Image
            width={144}
            height={144}
            src={blog.featuredImage.node.sourceUrl}
            alt={blog.featuredImage.node.altText}
            className="rounded-lg | h-18 w-18 object-cover"
          />
        )}
        <h4 className="text-paragraph-4 line-clamp-2">{blog.title}</h4>
      </Link>
    </article>
  )
}

export default InfluencerDetailsAsideContent
